var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReels = function SvgReels(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94762 0.0619048L8.24286 5.71429H0.5V5.2381C0.5 2.60952 2.42857 0.438095 4.94762 0.0619048ZM14.4333 5.71429H9.34286L6.00952 0H11.1L14.4333 5.71429ZM20.5 5.2381V5.71429H15.5333L12.2 0H15.2619C18.1571 0 20.5 2.34286 20.5 5.2381ZM0.5 6.66667V14.7619C0.5 17.6571 2.84286 20 5.7381 20H15.2619C18.1571 20 20.5 17.6571 20.5 14.7619V6.66667H0.5ZM13.3571 13.4238L9.55238 15.5857C8.91905 15.9476 8.11905 15.5 8.11905 14.781V10.4571C8.11905 9.7381 8.91905 9.29048 9.55238 9.65238L13.3571 11.8143C13.9905 12.1714 13.9905 13.0667 13.3571 13.4238Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reels.cd51da8e.svg";
export { ForwardRef as ReactComponent };